import { FormattedMessage } from 'react-intl';

import { PERMISSION } from 'src/features/auth/types';
import { parkingStatusMessages } from 'src/features/monitoring/utils/messages';
import { PATH } from 'src/features/navigation/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';
import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';

export default function MonitoringTabRow() {
    const accessPayStations = useHasPermissions([PERMISSION.ACCESS_PAY_STATIONS_MONITORING]);
    const accessDevices = useHasPermissions([PERMISSION.ACCESS_DEVICES_MONITORING]);
    const accessGateways = useHasPermissions([PERMISSION.ACCESS_GATEWAYS_MONITORING]);

    return (
        <TabRow>
            {accessGateways && (
                <Tab end to={`/${PATH.MONITORING}/gateways`}>
                    <FormattedMessage {...parkingStatusMessages.gateways} />
                </Tab>
            )}
            {accessPayStations && (
                <Tab end to={`/${PATH.MONITORING}/pay-station`}>
                    <FormattedMessage {...parkingStatusMessages.payStations} />
                </Tab>
            )}
            {accessDevices && (
                <Tab end to={`/${PATH.MONITORING}/devices`}>
                    <FormattedMessage {...parkingStatusMessages.devices} />
                </Tab>
            )}
        </TabRow>
    );
}
